module.exports = __webpack_public_path__ + "img/mts.b383eb91.jpg";